import styled from '@emotion/styled';
import { Typography, theme } from 'antd';
import { observer } from 'mobx-react-lite';

import { MainLayoutApplicationsMenuItem, type ApplicationsMenuItem } from './MainLayoutApplicationsMenuItem';

import type { ReactNode } from 'react';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 8px;
	overflow: hidden;
`;

const TitleContainer = styled.div`
	inline-size: 100%;
	padding-block: 10px;
	padding-inline: 14px;
`;

export interface MainLayoutApplicationsMenuContentProps {
	readonly items: ReadonlyArray<ApplicationsMenuItem>;
	readonly title?: ReactNode;
}

export const MainLayoutApplicationsMenuContent = observer(function MainLayoutApplicationsMenuContent({
	items,
	title = 'Applications',
}: MainLayoutApplicationsMenuContentProps) {
	const { token } = theme.useToken();

	return (
		<Container>
			<TitleContainer>
				<Typography.Text strong style={{ color: token.colorPrimaryText, fontSize: token.fontSizeSM }}>
					{title}
				</Typography.Text>
			</TitleContainer>
			{items.map((item) => (
				<MainLayoutApplicationsMenuItem key={item.id} {...item} />
			))}
		</Container>
	);
});
